import styled from 'styled-components'
import { Logo, Copy } from '@stokr/components-library'

// Scoped via styled-components so these rules can never leak onto other
// pages or federated remotes — see index.css (removed) for what happened
// when they were plain global selectors: `main { ... }` applied to every
// <main> on the page, including a federated remote's own <main>, since a
// bare-tag rule is lower specificity but still wins for any property the
// remote's own styles don't set.
const Main = styled.main`
  align-items: center;
  color: rgba(0, 0, 0, 0.87);
  display: flex;
  flex-direction: column;
  font-family: 'Open Sans', sans-serif;
  height: 100vh;
  justify-content: center;
  padding: 20px;
  text-align: center;
  width: 100vw;

  h1 {
    font-size: 40px;
    font-weight: 800;
    letter-spacing: 1.5px;
    text-transform: uppercase;

    @media screen and (max-width: 500px) {
      font-size: 28px;
    }
  }

  a,
  a:active,
  a:visited {
    color: rgba(0, 0, 0, 0.87);
  }
`

function UnderMaintenance() {
  return (
    <Main>
      <Logo />

      <h1>
        <Copy id="underMaintenance.message" /> <a href="mailto:help@stokr.io">help@stokr.io</a>
      </h1>
    </Main>
  )
}

export default UnderMaintenance
